export const getTableQrUrl = (tableUuid) => `${process.env.REACT_APP_QR_BASE_URL}/?uuid=${tableUuid}`;

export const getTableQrFileName = (table, extension) => `qr_${(table.name || table.id).toString().replace(/[^\p{L}\p{N}_-]+/gu, "_")}.${extension}`;

export const downloadCanvasAsPng = (canvas, fileName) => {
  const link = document.createElement("a");
  link.href = canvas.toDataURL("image/png");
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
